import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  ActiveModeCommands,
  Feature,
  FeatureNames,
  HeatingCurveCommands,
  HeatingCurveProperties,
  IsStringValueProperty,
  ZoneDemandProperties,
} from '@vi-iot/client';

import { DevicesStore, InstallationFeaturesStore, RichDevice } from '@store';

@Component({
  selector: 'app-heating-circuit-details-overlay',
  templateUrl: './heating-circuit-details-overlay.component.html',
  styleUrls: ['./heating-circuit-details-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingCircuitDetailsOverlayComponent implements OnInit, OnDestroy {
  heatingCurve$: Observable<Feature<HeatingCurveProperties, HeatingCurveCommands>>;
  operatingModesActive$: Observable<Feature<IsStringValueProperty, ActiveModeCommands>>;
  heatingZoneDemand$: Observable<Feature<ZoneDemandProperties, never>>;

  private _circuitId: string;
  @Input()
  set circuitId(id: string) {
    this._circuitId = id;
    this.selectFeatures();
  }
  get circuitId(): string {
    return this._circuitId;
  }
  remoteControllerDevices: RichDevice[];
  readonly featureNames = FeatureNames;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    public devicesStore: DevicesStore,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.operatingModesActive$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitActiveMode(this.circuitId)
    );

    this.heatingZoneDemand$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitHeatingZoneDemand(this.circuitId)
    );
  }

  private selectFeatures(): void {
    this.heatingCurve$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitHeatingCurve(this.circuitId)
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
